import Http from '@/services/http';

const url = {
  networkManagementList: '/Redes/listagem/',
  networkByInstallation: '/Redes/',
};

export default {
  getList(currentPage, perPage) {
    const http = new Http();
    let apiModel;
    return http
      .get(
        `${url.networkManagementList}?pagina=${currentPage}&tamanhoPagina=${perPage}`,
        apiModel,
      )
      .then(({ data }) => data);
  },
  getListByInstallation(installationId, currentPage, perPage) {
    const http = new Http();
    let apiModel;
    return http
      .get(
        `${url.networkByInstallation}${installationId}/listagem?pagina=${currentPage}&tamanhoPagina=${perPage}`,
        apiModel,
      )
      .then(({ data }) => data);
  },
};
